jQuery(document).ready(function($) {       

    let gainersLosersContainers = document.querySelectorAll('.ctp-gainers-losers-container');  

    // if there are some tables on the page
    if (gainersLosersContainers.length > 0) {       

        gainersLosersContainers.forEach(function(container) { 

            let dataLimit         = container.dataset.limit; 
            let dataMC            = container.dataset.mc; 
            let dataGainers       = container.dataset.gainers; 
            let dataPeriod        = container.dataset.period;
            
            // console.log( container, container.dataset);

            // initial - populate table
            ctpFillTable(container, dataLimit, dataMC, dataGainers, dataPeriod);   
         
            //Function to update each cell of the table    
            function ctpUpdateTable(container, coins, period ) {  

                if( container && coins && period ) {

                    let ctpGLBody          = container.querySelector('.ctp-gl-body'); // rows holder
                    let ctpGLRows          = ctpGLBody.querySelectorAll('.ctp-gl-row'); // array of rows

                    if( ctpGLRows.length > 0 ) {                             
                    
                        for (let i = 0; i < ctpGLRows.length ; i++) {                    
                            
                            let row = ctpGLRows[i]; 
                            if( undefined == coins[i] ) {
                                console.log( 'no coin' );
                            }    

                            if( undefined != coins[i] ) {
                                // console.log( coins[i] );

                                // name
                                let nameCell = row.querySelector('.ctp-name');
                                nameCell.textContent = coins[i].name;
                
                                // icon
                                let icon       = row.querySelector('.ctp-gl-coin-icon');
                                icon.innerHTML = '';

                                if ( undefined != coins[i].icon ) {
                                    let urlIcon = 'https://cryptify-platform-dev.clickoutmedia.tech' + coins[i].icon;
                                
                                    fetch(urlIcon)
                                        .then(response => {
                                            if (response.ok) {
                                                let img = $('<img>').attr('src', urlIcon).attr('alt', coins[i].name).attr('width', '21px').attr('height', '21px');
                                                icon.append(img[0]);
                                            } else {
                                                let img = $('<div>').addClass('ctp-grey-circle');
                                                icon.append(img[0]);
                                            }
                                        })
                                        .catch(error => {
                                            let img = $('<div>').addClass('ctp-grey-circle');
                                            icon.append(img[0]);
                                        });
                                } else {
                                    let img = $('<div>').addClass('ctp-grey-circle');
                                    icon.append(img[0]);
                                }      
                
                                // price
                                let price          = row.querySelector('.ctp-coin-price');
                                let rawPrice       = coins[i].price;
                                let formattedPrice = formatSmallPriceDollar(rawPrice);
                                price.setAttribute('data-number', rawPrice);
                                price.textContent  = formattedPrice;
                            
                
                                // change 
                                let change         = row.querySelector('.ctp-coin-change');                                
                                let changeCell     = row.querySelector('.ctp-coin-change-abs');
                                let changeFormated = formatAsPercentageAbs(coins[i][period]);
                                // console.log( coins[i][period]);
                                let rawChange      = coins[i][period];
                                changeCell.textContent = changeFormated;
                                
                                if( rawChange > 0 ) {
                                    change.classList.add( 'positive' );
                                    change.classList.remove( 'negative' );
                                } else {
                                    change.classList.add( 'negative' );
                                    change.classList.remove( 'positive' );
                                }
                            
                                
                                // remove skeleton
                                if (row.classList.contains('ctp-line-skeleton')) {
                                    row.classList.remove('ctp-line-skeleton');
                                } 

                            } else {
                                console.log( 'no coin' );
                            }
            
                            
                                                                                                   
                        }                       
                    }           
                }               
            }

            //Get data via AJAX by PHP proxy function (in order to hide API key) 
            function ctpGetCoinsAjax(limit, minMC, gainers, period ) {

                return new Promise((resolve, reject) => {                   
            
                    if (typeof ctpAjax === 'undefined' || typeof ctpAjax.ajax_url === 'undefined' || typeof ctpAjax.nonce === 'undefined') {
                        console.log('ctpAjax object or its properties are not defined.');
                        reject('ctpAjax object or its properties are not defined.');
                        return;
                    }
            
                    $.ajax({
                        url: ctpAjax.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'ctp_ajax_gainers_losers',
                            nonce: ctpAjax.nonce,
                            limit: limit,
                            min_mc: minMC,
                            gainers: gainers,
                            period: period,
                        },
                        success: function(response) {
                            try {  
                                resolve(response.coins);
                                // console.log( response.coins );
                            } catch (e) {
                                console.log('Error parsing response:', e);
                                reject(e);
                            }
                        },
                        error: function(xhr, status, error) {
                            console.log('AJAX call failed: ' + error);
                            reject(error);
                        }
                    });
                });
            }               

            //Function to fill the table with data
            function ctpFillTable(container, limit, mc, gainers, period) {

                // fetching coins, initial filling table 
                let coinsArray;
                ctpGetCoinsAjax(limit, mc, gainers, period)
                    .then(coins => {
                        coinsArray = coins;
                        ctpUpdateTable(container, coinsArray, period);
                    })
                    .catch(error => {
                        console.error('Error fetching coins:', error);
                    });             
            }
 

        });  
       
    }
 
});






               





